import { useEffect, useState } from "react";
import { PublicLayout } from "@/components/site/PublicLayout";
import { Breadcrumbs } from "@/components/site/Breadcrumbs";
import { api, fileUrl } from "@/lib/api";
import { Newspaper, Paperclip } from "lucide-react";
import { format } from "date-fns";

export default function News() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/news").then((r) => setItems(r.data)); }, []);

    return (
        <PublicLayout>
            <section className="container-x pt-10">
                <Breadcrumbs items={[{ label: "News" }]} />
                <div className="mt-5">
                    <div className="overline">Latest</div>
                    <h1 className="mt-3 font-serif text-5xl text-slate-900 sm:text-6xl">News & Announcements</h1>
                    <p className="mt-4 max-w-2xl text-lg text-slate-600">Fresh updates from the association and our member societies.</p>
                </div>
            </section>

            <section className="container-x mt-10 pb-20">
                <div className="grid gap-8">
                    {items.map((n, i) => (
                        <article key={n.id} className="surface-card-hover grid gap-6 overflow-hidden md:grid-cols-3" data-testid={`news-${n.id}`}>
                            <div className="relative h-52 bg-gradient-to-br from-brand-blue-light to-white md:h-full">
                                {n.featured_image_id ? (
                                    <img src={fileUrl(n.featured_image_id)} alt={n.title} className="h-full w-full object-cover" loading="lazy" />
                                ) : (
                                    <div className="grid h-full place-items-center text-brand-blue/40"><Newspaper size={56} /></div>
                                )}
                            </div>
                            <div className="md:col-span-2 p-6">
                                <div className="text-xs text-slate-500">{n.publish_date ? format(new Date(n.publish_date), "dd MMMM yyyy") : ""}</div>
                                <h2 className="mt-2 font-serif text-3xl text-slate-900">{n.title}</h2>
                                <p className="mt-4 leading-relaxed text-slate-600">{n.description}</p>
                                {n.attachment_ids?.length > 0 && (
                                    <div className="mt-5 flex flex-wrap gap-2">
                                        {n.attachment_ids.map((id) => (
                                            <a key={id} href={fileUrl(id)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-3 py-1 text-xs hover:border-brand-blue hover:text-brand-blue">
                                                <Paperclip size={12} /> Attachment
                                            </a>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </article>
                    ))}
                    {items.length === 0 && <div className="py-16 text-center text-slate-500">No news items yet.</div>}
                </div>
            </section>
        </PublicLayout>
    );
}
